export const GET_SAMPLE_REQUEST = 'GET_SAMPLE_REQUEST';
export const GET_SAMPLE_SUCCESS = 'GET_SAMPLE_SUCCESS';
export const GET_SAMPLE_ERROR = 'GET_SAMPLE_ERROR';

export const GET_SAMPLE_LIST_REQUEST = 'GET_SAMPLE_LIST_REQUEST';
export const GET_SAMPLE_LIST_SUCCESS = 'GET_SAMPLE_LIST_SUCCESS';
export const GET_SAMPLE_LIST_ERROR = 'GET_SAMPLE_LIST_ERROR';

export const ADD_SAMPLE_REQUEST = 'ADD_SAMPLE_REQUEST';
export const ADD_SAMPLE_SUCCESS = 'ADD_SAMPLE_SUCCESS';
export const ADD_SAMPLE_ERROR = 'ADD_SAMPLE_ERROR';

export const UPDATE_SAMPLE_REQUEST = 'UPDATE_SAMPLE_REQUEST';
export const UPDATE_SAMPLE_SUCCESS = 'UPDATE_SAMPLE_SUCCESS';
export const UPDATE_SAMPLE_ERROR = 'UPDATE_SAMPLE_ERROR';

export const DELETE_SAMPLE_REQUEST = 'DELETE_SAMPLE_REQUEST';
export const DELETE_SAMPLE_SUCCESS = 'DELETE_SAMPLE_SUCCESS';
export const DELETE_SAMPLE_ERROR = 'DELETE_SAMPLE_ERROR';

export const GET_SAMPLE_DROPDOWN_REQUEST = 'GET_SAMPLE_DROPDOWN_REQUEST';
export const GET_SAMPLE_DROPDOWN_SUCCESS = 'GET_SAMPLE_DROPDOWN_SUCCESS';
export const GET_SAMPLE_DROPDOWN_ERROR = 'GET_SAMPLE_DROPDOWN_ERROR';

export const ADD_SAMPLE_COLOR_REQUEST = 'ADD_SAMPLE_COLOR_REQUEST';
export const ADD_SAMPLE_COLOR_SUCCESS = 'ADD_SAMPLE_COLOR_SUCCESS';
export const ADD_SAMPLE_COLOR_ERROR = 'ADD_SAMPLE_COLOR_ERROR';

export const GET_SAMPLE_COLORS_REQUEST = 'GET_SAMPLE_COLORS_REQUEST';
export const GET_SAMPLE_COLORS_SUCCESS = 'GET_SAMPLE_COLORS_SUCCESS';
export const GET_SAMPLE_COLORS_ERROR = 'GET_SAMPLE_COLORS_ERROR';

export const UPDATE_SAMPLE_COLOR_REQUEST = 'UPDATE_SAMPLE_COLOR_REQUEST';
export const UPDATE_SAMPLE_COLOR_SUCCESS = 'UPDATE_SAMPLE_COLOR_SUCCESS';
export const UPDATE_SAMPLE_COLOR_ERROR = 'UPDATE_SAMPLE_COLOR_ERROR';

export const DELETE_SAMPLE_COLOR_REQUEST = 'DELETE_SAMPLE_COLOR_REQUEST';
export const DELETE_SAMPLE_COLOR_SUCCESS = 'DELETE_SAMPLE_COLOR_SUCCESS';
export const DELETE_SAMPLE_COLOR_ERROR = 'DELETE_SAMPLE_COLOR_ERROR';

export const CREATE_SAMPLE_WITH_COLORS_REQUEST = 'CREATE_SAMPLE_WITH_COLORS_REQUEST';
export const CREATE_SAMPLE_WITH_COLORS_SUCCESS = 'CREATE_SAMPLE_WITH_COLORS_SUCCESS';
export const CREATE_SAMPLE_WITH_COLORS_ERROR = 'CREATE_SAMPLE_WITH_COLORS_ERROR';

export const CREATE_WEAVE_FROM_SAMPLE_REQUEST = 'CREATE_WEAVE_FROM_SAMPLE_REQUEST';
export const CREATE_WEAVE_FROM_SAMPLE_SUCCESS = 'CREATE_WEAVE_FROM_SAMPLE_SUCCESS';
export const CREATE_WEAVE_FROM_SAMPLE_ERROR = 'CREATE_WEAVE_FROM_SAMPLE_ERROR';
